import en_US from './en_US'
import zh_CN from './zh_CN'
import zh_HANT from './zh_HANT'
export default {
  en_US: en_US,
  zh_CN: zh_CN,
  zh_HANT: zh_HANT
}



// WEBPACK FOOTER //
// ./src/i18n/language/index.js